module.exports = __webpack_public_path__ + "img/PRCA1_Neutrophils.8cec0116.png";